module.exports = __webpack_public_path__ + "static/media/yosemity-falls-min.9f86c805.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/yosemity-falls-min.jpg
// module id = 45
// module chunks = 0